import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ConfirmCartComponent } from './confirm-cart/confirm-cart.component';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { ILead, IResponse } from 'app/core/shared-services/shared-interface.types';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { MatButtonModule } from '@angular/material/button';
import { IPackages, iTerms } from 'app/core/shared-services/interfaces.types';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { AuthService } from 'app/core/auth/auth.service';
import { OrderDetailsComponent } from '../order-process/confirm-order/order-details/order-details.component';
import { SummaryComponent } from '../order-process/confirm-order/summary/summary.component';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { PaymentComponent } from '../order-process/confirm-order/payment/payment.component';
import { LoginExistingComponent } from './login-existing/login-existing.component';
import { isPlatformBrowser, NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { firstValueFrom } from 'rxjs';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';

@Component({
  selector: 'app-sales-agent',
  standalone: true,
  imports: [
    MatStepperModule, MatButtonModule, RouterLink, PaymentComponent, SummaryComponent, 
    OrderDetailsComponent, RouterLink, FuseAlertComponent, CreatePasswordComponent, 
    ConfirmCartComponent, LoginExistingComponent, NgIf, MatProgressSpinnerModule],
  templateUrl: './sales-agent.component.html',
  styleUrl: './sales-agent.component.scss'
})
export class SalesAgentComponent implements OnInit {

  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild(PaymentComponent) paymentComponent: PaymentComponent;

  public emailToken: any;

  public leadEntityID: any;
  public leadResult: any;
  public lead: ILead;

  public passwordToken: any;
  public userName: any;
  public leadRegistrationToken: any;

  public disablePasswordButton: boolean = true;
  public password: string;

  public confirmOrderForm: any;
  public confirmOrderValid: boolean = false;

  public isExistingCustomer: boolean;
  public existingUsername: string;
  public existingLeadNumber: string;
  public existingCustomerPassword: string;
  public dealerCode: string;
  public disableLoginBtn: boolean = false;
  public loginLoading: boolean = false;
  public btnLoading: boolean = false;
  public showSummaryBtn: boolean = false;
  
  public termsAndConditions: Array<iTerms>
  public pdfTermsAndConditions: string;
  public allTermsAccepted: boolean = false;

  public alert: { type: FuseAlertType; message: string };
  public showAlert: boolean = false;

  private updateLeadResult: any;

  public hasFibreInstalled: boolean = false;

  public channelPartnerOrderResult: any;  
  
  public center: { lat: number, lng: number};

  private orderResult: any;
  public order: Array<IPackages>;
  public addOns: Array<IPackages>;
  public upFrontAmount: number = 0;
  public monthlyAmount: number = 0;

  public terms: Array<iTerms>;

  private upFrontAmountResult: any;
  public beforeTax: number = 0;
  public VAT: number = 0;
  public totalAmount: number = 0;

  private leadActionType: any;

  private referrer: string;
  public isDealerJourney: boolean = false;

  public hasPaymentMethod: boolean = false;

  public acceptedTerms: any;


  /**
    * Constructor
  */

  constructor(
    private _sharedMethods: SharedMethodsModule,
    private activatedRouter: ActivatedRoute,
    private _authService: AuthService,
    private _gtmService: GtmService,
    private _webStorage: WebStorage,
    private _router : Router,
    
    @Inject(PLATFORM_ID) private platformId: any
  ) { }


  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  async ngOnInit() {

    await this.clearLocalStorage();

    this.isDealerJourney = this.activatedRouter.snapshot.url.some(segment => segment.path === 'pre-orders');

    if (isPlatformBrowser(this.platformId)) {

      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }
  
      const route = window.location.href;
      const path = this._router.url;
      this._gtmService.pushEvent({ 
        event: 'page_view',
        page_url: route,
        page_path: path,
        page_referrer: this.referrer ? this.referrer : route,
        page_title: 'pre-orders_page',
      });
    }


    this.isExistingCustomer = await this.checkIfExistingCustomer();

    if(this.activatedRouter.snapshot.queryParamMap.get('lead_id')) {
      this.leadResult = await this._sharedMethods.getLeadById(this.activatedRouter.snapshot.queryParamMap.get('lead_id'));
      this.dealerCode = this.leadResult.result?.SalesAgentUserEntityID;
      localStorage.setItem('DealerCode', this.dealerCode);

      if(this.leadResult.success) {
        this.lead = this.leadResult.result;
        this.center = {lat: this.lead?.Latitude, lng: this.lead?.Longitude};

        // Get Linked offerables on lead
        this.orderResult = await this._sharedMethods.getLinkedOfferablesByLeadId(this.lead.LeadEntityID);
        if(this.orderResult.success) {
          this.order = this.orderResult.result.filter(item => !item.IsAddOn);
          localStorage.setItem('preorderPackageEntityId', JSON.stringify(this.order[0]?.PackageEntityID))
          this.addOns = this.orderResult.result.filter(item => item.IsAddOn);
          this.order.forEach(item => {
            if(item.Billing_IsRecurring) {
              this.monthlyAmount += item.Billing_TotalIncl
            }
          });
        }

        // Get upfront Payment
        this.upFrontAmountResult = await this._sharedMethods.getUpfrontAmountDue(this.lead.LeadEntityID);
        if(this.upFrontAmountResult.success) {
          this.upFrontAmount = this.upFrontAmountResult.result;
          this.VAT = (15 / 100) * this.upFrontAmount;
        }
      }
    }

    if (!this.isExistingCustomer) {

      if(this.activatedRouter.snapshot.queryParamMap.get('password_token')) {
        this.passwordToken = this.activatedRouter.snapshot.queryParamMap.get('password_token');
      }

      if(this.activatedRouter.snapshot.queryParamMap.get('email_token')) {
        this.emailToken = this.activatedRouter.snapshot.queryParamMap.get('email_token');
  
        try {
          this._authService.verifyEmailAddress(this.emailToken)
          .subscribe({
            next: async () => {
            },
            error: async(err) => {
              const exMessage : string = err.error.ExceptionMessage;
              if (exMessage?.includes("Account not found")) {
                this.isExistingCustomer = false;
              }
            }
          });
        } catch (error) {
          console.error(error);
        }
  
      }
    }

    if(this.activatedRouter.snapshot.queryParamMap.get('LeadRegistrationToken')) {
      this.leadRegistrationToken = this.activatedRouter.snapshot.queryParamMap.get('LeadRegistrationToken');
    }

    // make sure we have all the param details
    // then clear 
    // if (this.userName && this.passwordToken && this.emailToken && this.leadRegistrationToken) {
    //   this.activatedRouter.snapshot.queryParamMap.
    // }

    if (localStorage.getItem('preorderCustomerLoggedIn')) {
      localStorage.removeItem('preorderCustomerLoggedIn')
      for (let i = 0; i < 2; i++) {
        this.stepper.next();
      }
    }
   }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

   public async checkout() {
    this.btnLoading = true;
    this.leadResult = await this._sharedMethods.getLeadById(this.lead?.LeadEntityID);

      if (this.leadResult.success) {
        this.gtmPushEvent('pre-orders_page', `confirm_cart_${this.isDealerJourney ? 'dealer' : 'online'}`);
        this.lead = this.leadResult.result;

        // set Lead Description
        this.lead.LeadDescription = 'Order';
        this.lead.LeadActionTypeCode = 'Order';

        // set Lead Notes
        this.lead.LeadNotes = 'Address has Fibre installed: ' + this.hasFibreInstalled;
        

        // update lead
        this.updateLeadResult = await this._sharedMethods.updateLead(this.lead);
        this.next();
        this.isCustomerLoggedIn();
        this.btnLoading = false;
        
      }
  }

  public next() {
    this.stepper.next();
  }

  public hasPaymentMethodEvent(val: boolean) {
    this.hasPaymentMethod = val;
  }

  public termsCheckedValue(val: boolean) {
    this.acceptedTerms = val;
    if(this.acceptedTerms.length == 0) {
      this.allTermsAccepted = false;
    }
    this.allTermsAccepted = this.acceptedTerms.every(element => element.isAccepted);

  }

  public passwordEvent(val: any) {
   if(val.password) {
    this.password = val.password;
     this.disablePasswordButton = false;
   } else {
     this.disablePasswordButton = true;
   }
  }

  public isTermsComplete(event: any) {
    const termsArray = event;
    if (termsArray.every(t => t.isAccepted === true)) {
      this.showSummaryBtn = true;
    } else {
      this.showSummaryBtn = false;
    }
  }

  public async createPassword() {
    this.btnLoading = true;
    this._authService.resetPassword(this.password, this.passwordToken, this.userName)
      .subscribe({
        next: async () => {
          // this.gtmPushEvent('pre-orders_page', )

          if(localStorage.getItem('currentURL')) {
            if(localStorage.getItem('currentURL') == window.location.href) {
            } else {
              this.referrer = localStorage.getItem('currentURL')
              localStorage.setItem('currentURL', window.location.href);
              localStorage.setItem('previousURL', this.referrer);
            }
          } else {
            localStorage.setItem('currentURL', window.location.href);
          }
      
          const route = window.location.href;
          const path = this._router.url;
          this._gtmService.pushEvent({ 
            event: `sign_in_${this.isDealerJourney ? 'dealer' : 'online'}`,
            page_url: route,
            page_path: path,
            page_referrer: this.referrer ? this.referrer : route,
            page_title: 'pre-orders_page',
            customer_type: this.isExistingCustomer ? 'existing' : 'new',
            dealer_code: this.dealerCode,
          });


          this.alert = { type:'success', message: 'Password reset successful'};
          this.showAlert = true;

          this.channelPartnerOrderResult = await this._sharedMethods.channelPartnerOrder(this.lead.LeadEntityID, false)

          this._authService.signIn({Username: this.userName, Password: this.password}).subscribe({
            next: async () => {
              await this.updateCPLead();
              this.btnLoading = false;
            }, error: () => {
              this.alert = { type: 'error', message: 'Password reset successful but login failed'};
              this.showAlert = true;
              this.btnLoading = false;
            }
          })

          
          this.stepper.next();

          //GTM EVENT FOR Summary page view
          if(localStorage.getItem('currentURL')) {
            if(localStorage.getItem('currentURL') == window.location.href) {
            } else {
              this.referrer = localStorage.getItem('currentURL')
              localStorage.setItem('currentURL', window.location.href);
              localStorage.setItem('previousURL', this.referrer);
            }
          } else {
            localStorage.setItem('currentURL', window.location.href);
          }
      
          this._gtmService.pushEvent({ 
            event: `order_summary_${this.isDealerJourney ? 'dealer' : 'online'}`,
            page_url: route,
            page_path: path,
            page_referrer: this.referrer ? this.referrer : route,
            page_title: 'pre-orders_page',
            dealer_code: this.dealerCode,
          });


        }, error: () => {
          this.alert = { type: 'error', message: 'Password reset failed'};
          this.showAlert = true;

          
        }
      })
  }

  public summaryNext() {
    //GTM EVENT FOR CONFRIM ORDER CLICK
    if(localStorage.getItem('currentURL')) {
      if(localStorage.getItem('currentURL') == window.location.href) {
      } else {
        this.referrer = localStorage.getItem('currentURL')
        localStorage.setItem('currentURL', window.location.href);
        localStorage.setItem('previousURL', this.referrer);
      }
    } else {
      localStorage.setItem('currentURL', window.location.href);
    }

    const route = window.location.href;
    const path = this._router.url;
    this._gtmService.pushEvent({ 
      event: `confirm_order_${this.isDealerJourney ? 'dealer' : 'online'}`,
      page_url: route,
      page_path: path,
      page_referrer: this.referrer ? this.referrer : route,
      page_title: 'pre-orders_page',
      dealer_code: this.dealerCode,
    });


    //Payment page view
    if(localStorage.getItem('currentURL')) {
      if(localStorage.getItem('currentURL') == window.location.href) {
      } else {
        this.referrer = localStorage.getItem('currentURL')
        localStorage.setItem('currentURL', window.location.href);
        localStorage.setItem('previousURL', this.referrer);
      }
    } else {
      localStorage.setItem('currentURL', window.location.href);
    }

    // const route = window.location.href;
    // const path = this._router.url;
    this._gtmService.pushEvent({ 
      event: `payment_page_view_${this.isDealerJourney ? 'dealer' : 'online'}`,
      page_url: route,
      page_path: path,
      page_referrer: this.referrer ? this.referrer : route,
      page_title: 'pre-orders_page',
      dealer_code: this.dealerCode,
    });
    this.isCustomerLoggedIn();
  }

  public confirmOrder(val: any) {
    if (val !== null) {
      this.confirmOrderValid = true;
      this.confirmOrderForm = val;
    } else {
      this.confirmOrderValid = false;
    }
  }

  public async updateCPLead() {
   await this._sharedMethods.channelPartnerOrder(this.lead.LeadEntityID, true);
   this.lead.PaymentType = 'DebitOrder';
   await this._sharedMethods.updateLead(Object.assign(this.lead, this.confirmOrderForm));
  }
  
  public async placeOrder() {
    this.btnLoading = true;

    if(localStorage.getItem('currentURL')) {
      if(localStorage.getItem('currentURL') == window.location.href) {
      } else {
        this.referrer = localStorage.getItem('currentURL')
        localStorage.setItem('currentURL', window.location.href);
        localStorage.setItem('previousURL', this.referrer);
      }
    } else {
      localStorage.setItem('currentURL', window.location.href);
    }

    const route = window.location.href;
    const path = this._router.url;
    this._gtmService.pushEvent({ 
      event: `place_order_${this.isDealerJourney ? 'dealer' : 'online'}`,
      page_url: route,
      page_path: path,
      page_referrer: this.referrer ? this.referrer : route,
      page_title: 'pre-orders_page',
      dealer_code: this.dealerCode,
    });
    
    const newOrder = await this._sharedMethods.getLeadById(this.lead.LeadEntityID);
    const orderDetails = newOrder.result;

    this.btnLoading = false;
    this._webStorage.UpdateCart('remove');
    localStorage.removeItem('LeadEntityID');


    //ORDER COMPLETE
    if(localStorage.getItem('currentURL')) {
      if(localStorage.getItem('currentURL') == window.location.href) {
      } else {
        this.referrer = localStorage.getItem('currentURL')
        localStorage.setItem('currentURL', window.location.href);
        localStorage.setItem('previousURL', this.referrer);
      }
    } else {
      localStorage.setItem('currentURL', window.location.href);
    }

    this._gtmService.pushEvent({ 
      event: `order_complete_${this.isDealerJourney ? 'dealer' : 'online'}`,
      page_url: route,
      page_path: path,
      page_referrer: this.referrer ? this.referrer : route,
      page_title: 'pre-orders_page',
      order_number: orderDetails.LeadNumber,
      order_value: orderDetails.ContractTotalRecurringIncl,
      dealer_code: this.dealerCode,
    });

    this.btnLoading = false;
    this._webStorage.UpdateCart('remove');
    localStorage.removeItem('LeadEntityID');
    localStorage.removeItem('DealerCode');
  }

  private async checkIfExistingCustomer() {
    const password_token = this.activatedRouter.snapshot.queryParamMap.get('password_token');
    const email_token = this.activatedRouter.snapshot.queryParamMap.get('email_token');
    if(password_token && email_token) {
      this.userName = encodeURI(this.activatedRouter.snapshot.queryParamMap.get('username')).replace('%20', '+').replace('%40', '@');

      return false
    } else {
      
      this.existingLeadNumber = this.activatedRouter.snapshot.queryParamMap.get('lead_id');
      let username: string;
      username =this.activatedRouter.snapshot.queryParamMap.get('username')
      if (username?.includes(' ')) {
        username = username.replace(' ', '+');
    }
      this.existingUsername = username;
      return true
    }

  }


  async existingLogin() {
    this.loginLoading = true;
    const credentials = {
      Username: this.existingUsername,
      Password: this.existingCustomerPassword,
    }
    this._authService.signIn(credentials).subscribe({
      next: async () => {

        this.loginLoading = false;

        if(localStorage.getItem('currentURL')) {
          if(localStorage.getItem('currentURL') == window.location.href) {
          } else {
            this.referrer = localStorage.getItem('currentURL')
            localStorage.setItem('currentURL', window.location.href);
            localStorage.setItem('previousURL', this.referrer);
          }
        } else {
          localStorage.setItem('currentURL', window.location.href);
        }
    
        const route = window.location.href;
        const path = this._router.url;
        this._gtmService.pushEvent({ 
          event: `sign_in_${this.isDealerJourney ? 'dealer' : 'online'}`,
          page_url: route,
          page_path: path,
          page_referrer: this.referrer ? this.referrer : route,
          page_title: 'pre-orders_page',
          customer_type: this.isExistingCustomer ? 'existing' : 'new',
          dealer_code: this.dealerCode,
        });

        localStorage.setItem('preorderCustomerLoggedIn', 'true');
        location.reload();

        //Summary View - GTM Event
        if(localStorage.getItem('currentURL')) {
          if(localStorage.getItem('currentURL') == window.location.href) {
          } else {
            this.referrer = localStorage.getItem('currentURL')
            localStorage.setItem('currentURL', window.location.href);
            localStorage.setItem('previousURL', this.referrer);
          }
        } else {
          localStorage.setItem('currentURL', window.location.href);
        }
    
        this._gtmService.pushEvent({ 
          event: `order_summary_${this.isDealerJourney ? 'dealer' : 'online'}`,
          page_url: route,
          page_path: path,
          page_referrer: this.referrer ? this.referrer : route,
          page_title: 'pre-orders_page',
          dealer_code: this.dealerCode,
        });

      }, error: (err) => {
        this.alert = { type: 'error', message: err.error};
        this.showAlert = true;
        this.loginLoading = false;
      }
    });
  }

  captureLoginPassword(event: any) {
    this.existingCustomerPassword = event.password;
  }

  private gtmPushEvent(title: string, event: string) {

    if(localStorage.getItem('currentURL')) {
      if(localStorage.getItem('currentURL') == window.location.href) {
      } else {
        this.referrer = localStorage.getItem('currentURL')
        localStorage.setItem('currentURL', window.location.href);
        localStorage.setItem('previousURL', this.referrer);
      }
    } else {
      localStorage.setItem('currentURL', window.location.href);
    }

    const route = window.location.href;
    const path = this._router.url;
    this._gtmService.pushEvent({ 
      event: `${event}`,
      page_url: route,
      page_path: path,
      page_referrer: this.referrer ? this.referrer : route,
      page_title: `${title}`,
      dealer_code: this.dealerCode
    });
  }

  private isCustomerLoggedIn() {
    if (this._authService.accessToken) {
      this.stepper.next();
    }
  }

  private async clearLocalStorage() {
    localStorage.clear();
  }


}

